const aspectRatio = (width, height) => (height / width) * 100;
export default aspectRatio;
